export default __webpack_public_path__ + "static/sf-illustration-white-a63f87f764bb7b878418e1db387dd567.svg";